(function () {
    if (customElements.get('gifting-combos')) return;
    class GiftingCombos extends HTMLElement {
      connectedCallback() {
        this.addLabel = this.dataset.addLabel;
        this.setupTabs();
        this.querySelectorAll('[data-more]').forEach((btn) => btn.addEventListener('click', () => this.toggleMore(btn)));
        this.querySelectorAll('.gf-card').forEach((card) => this.setupCard(card));
      }
      setupTabs() {
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;
        const select = (tab) => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        };
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => select(tab));
          tab.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
              select(next); next.focus();
            }
          });
        });
      }
      toggleMore(btn) {
        const panel = btn.closest('.gf-panel');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        panel.querySelectorAll('[data-extra]').forEach((el) => (el.hidden = expanded));
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.textContent = expanded ? btn.dataset.moreLabel : btn.dataset.lessLabel;
        if (expanded) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      setupCard(card) {
        const qty = card.querySelector('.gf-qty__input');
        const addBtn = card.querySelector('.gf-add');
        if (!qty || !addBtn) return;
        card.querySelector('[data-action="decrease"]').addEventListener('click', () => { qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
        card.querySelector('[data-action="increase"]').addEventListener('click', () => { qty.value = Math.min(99, parseInt(qty.value, 10) + 1); });
        addBtn.addEventListener('click', () => this.add(addBtn, qty));
      }
      add(addBtn, qty) {
        if (addBtn.disabled) return;
        const text = addBtn.querySelector('.btn-text');
        const quantity = parseInt(qty.value, 10) || 1;
        addBtn.disabled = true;
        addBtn.classList.add('loading');
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id).join(',') : 'cart-icon-bubble';
        const item = { id: addBtn.dataset.variantId, quantity };
        if (this.dataset.campaign) item.properties = { Campaign: this.dataset.campaign };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item], sections, sections_url: window.location.pathname })
        })
          .then((r) => r.json())
          .then((json) => {
            if (json.status) throw new Error(json.description || this.dataset.errorLabel);
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { 'Order Source': this.dataset.campaign ? 'Reel competition page' : 'Gifting page', Program: 'T1D Warriors' } })
            });
            if (drawer) {
              drawer.renderContents(json);
            } else {
              const bubble = document.getElementById('cart-icon-bubble');
              if (bubble && json.sections && json.sections['cart-icon-bubble']) {
                bubble.innerHTML = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
              }
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gifting-grid', cartData: json });
            document.dispatchEvent(new CustomEvent('gifting:cart-updated'));
            addBtn.classList.remove('loading');
            addBtn.classList.add('is-added');
            text.textContent = this.dataset.addedLabel;
            text.insertAdjacentHTML('beforeend', ' <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>');
            setTimeout(() => { text.textContent = this.addLabel; addBtn.classList.remove('is-added'); addBtn.disabled = false; }, 1400);
          })
          .catch(() => {
            addBtn.classList.remove('loading');
            addBtn.disabled = false;
            text.textContent = this.dataset.errorLabel;
            setTimeout(() => { text.textContent = this.addLabel; }, 2000);
          });
      }
    }
    customElements.define('gifting-combos', GiftingCombos);
  })();
